import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { PrismicRichText } from '@prismicio/react'

// Components
import CategoryCard from '../components/categoryCard'

import Logo from './svg/logoIcon'

const CaseStudies = ({ slice }) => {
  const data = useStaticQuery(graphql`
    {
      allPrismicCaseStudy(limit: 3, sort: { last_publication_date: DESC }) {
        edges {
          node {
            ...PrismicCaseStudyFragment
          }
        }
      }
    }
  `)
  const articles = data.allPrismicCaseStudy.edges
  if (!articles) return null
  return (
    <section className='case-studies py-10 relative max-w-screen-xl mx-auto'>
      <Logo className='absolute inset-0 py-5 opacity-5 -z-0 max-w-screen-md mx-auto text-brand-orange' />
      {slice?.primary.title && (
        <div className='prose prose-lg px-6 max-w-screen-md mx-auto text-center'>
          <PrismicRichText field={slice.primary.title.richText} />
          <PrismicRichText field={slice.primary.text.richText} />
        </div>
      )}
      <div className='p-6 relative mx-auto max-w-screen-2xl sm:px-6 sm:pb-8 md:py-8'>
        <ul className='grid grid-cols-1 gap-6 md:grid-cols-3'>
          {articles.map((item, index) => {
            return <CategoryCard item={item} key={`item-${index}`} />
          })}
        </ul>
      </div>
    </section>
  )
}

export default CaseStudies
